import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from "photoswipe/lightbox"

// Enlarges a tweet's photo grid on click. One instance per feed card, since feed cards are
// added/removed by infinite scroll/Turbo Frames — disconnect tears the instance down so those
// don't leak.
export default class extends Controller {
  static values = { children: { type: String, default: "a" } }

  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: `#${this.element.id}`,
      children: this.childrenValue,
      pswpModule: () => import("photoswipe"),
    })
    this.lightbox.init()
  }

  disconnect() {
    this.lightbox?.destroy()
    this.lightbox = null
  }
}
